import { useModal } from '@billy/design-system'
import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { fetchAttachments } from '../../../query-api'
import { QueryProps } from '../../../types/queryProps'
import { getAttachmentsQueryKey } from '../../../utils/getAttachmentsQueryKey'
import { useChooseAttachmentModal } from '../contexts/chooseAttachmentModalContext'

export const useAttachmentsForModal = () => {
  const { organization } = useUserOrganization()
  const {
    filters: { page, pageSize, searchQuery, sortDirection, sortProperty, type, fillType },
    idsToSkip,
    modalId,
  } = useChooseAttachmentModal()
  const { isOpen: enabled } = useModal(modalId)

  const queryProps: QueryProps = useMemo(
    () => ({
      fillType,
      organizationId: organization?.id as string,
      page,
      pageSize,
      searchQuery,
      sortDirection,
      sortProperty,
      type,
    }),
    [fillType, organization?.id, page, pageSize, searchQuery, sortDirection, sortProperty, type],
  )

  const queryKey = getAttachmentsQueryKey(queryProps)

  const { data, ...rest } = useQuery(queryKey, () => fetchAttachments(queryProps), {
    enabled: !!organization && enabled,
  })

  const attachmentsFiltered = useMemo(
    () => data?.attachments.filter((attachment) => !idsToSkip?.includes(attachment.id)),
    [data?.attachments, idsToSkip],
  )

  return {
    attachments: attachmentsFiltered || [],
    pagination: data?.meta.paging,
    ...rest,
  }
}
